module.exports = __webpack_public_path__ + "img/defkf2.d59dd045.png";